/* eslint-disable class-methods-use-this */
class DiscountValidation extends HTMLElement {
  constructor() {
    super();
    this.submitButton = this.querySelector('.modal-button');
    this.modalInput = this.querySelector('.modal-input');
  }

  connectedCallback() {
    this.submitButton.addEventListener('click', (event) => this.handleSubmit(event));
    this.modalInput.addEventListener('keydown', () => this.hideErrorMessage());
    this.autoOpenModal();
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setLoading(true);
    const discountCode = this.modalInput.value;

    if (!discountCode) {
      this.showErrorMessage('Enter a discount code');
      this.setLoading(false);
      return;
    }

    const response = await this.getDiscount(discountCode);

    if (!response.isValid) {
      this.showErrorMessage(response.error);
      this.setLoading(false);
      return;
    }

    if (discountCode.toUpperCase().includes('GIFT-')) {
      window.location.assign(`/pages/redeem-gift?discount_code=${discountCode}`);
      return;
    }

    // Use landing page add-to-cart for non-gift codes
    if (window.__CGC?.addToCartWithDiscount) {
      const result = await window.__CGC.addToCartWithDiscount(discountCode);

      if (result.success) {
        // Close the modal
        this.closeModal();
        this.setLoading(false);
      } else {
        this.showErrorMessage(result.error || 'Could not add to cart. Please try again.');
        this.setLoading(false);
      }
    } else {
      // Fallback: redirect to sign-up if addToCartWithDiscount not available
      console.warn('[DiscountValidation] addToCartWithDiscount not available, falling back to sign-up redirect');
      window.location.assign(`/pages/sign-up?discount_code=${discountCode}`);
    }
  }

  closeModal() {
    // Find and close the modal
    const modal = this.closest('details-modal') || this.closest('.modal');
    if (modal) {
      if (modal.close) {
        modal.close();
      } else {
        // Try to find close button
        const closeButton = modal.querySelector('.modal__close-button, [data-modal-close]');
        if (closeButton) {
          closeButton.click();
        }
      }
    }
  }

  async getDiscount(code) {
    const nodeRedDomain = 'https://nr-api.craftginclub.co.uk';

    const response = await fetch(`${nodeRedDomain}/public/shopify/discount?discount_code=${code}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });

    return response.json();
  }

  setLoading(loading) {
    if (loading) {
      this.disableSubmit();
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading__spinner').classList.add('hidden');
    }
  }

  hideErrorMessage() {
    const errorField = this.querySelector('#discount_error');
    if (!errorField.classList.contains('hidden')) {
      errorField.classList.add('hidden');
    }
  }

  showErrorMessage(message) {
    const errorField = this.querySelector('#discount_error');
    errorField.innerHTML = message;
    errorField.classList.remove('hidden');
  }

  disableSubmit() {
    this.submitButton.disabled = 'true';
  }

  autoOpenModal() {
    if (window.location.hash == '#got-a-discount') {
      const button = document.querySelector('.opener-button-container').querySelector('button');
      button.click();
    }
  }
}

if (!customElements.get('discount-validation')) {
  window.customElements.define('discount-validation', DiscountValidation);
}
